<template>
  <bg-topbar
    :footer-menu-items="footerMenuItems"
    :profile-menu-item-groups="visibleProfileMenuItemGroups"
    :profile-full-name="props.loggedUser?.name || '?'"
  >
    <template #left>
      <bg-topbar-item>
        <bg-logo
          to="/"
          height="32px"
          aria-label="Ir para a página inicial"
        />
      </bg-topbar-item>
    </template>

    <template #right>
      <span
        v-if="waitingValue && !validationAccount"
        class="app-topbar-pending-balance"
      >
        Aguardando recebimento:
        <router-link
          tabindex="2"
          class="cursor-pointer"
          :to="{ name: 'BatchesWaitingToReceive' }"
        >
          {{ $format.currency(waitingValue) }}
        </router-link>
      </span>
    </template>
  </bg-topbar>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, reactive } from 'vue';
import { BgLogo, BgTopbar, BgTopbarItem } from '@transfeeradev/bridge';
import config from '@/config';
import { useAllowedRoute } from '@/commons/composables/useAllowedRoute';
import { usePaymentsBalance } from '@/commons/composables/usePaymentsBalance';
import { isAppAllowed } from '@/commons/services/apps';
import { APPS } from '@/commons/constants/apps';

defineOptions({
  name: 'top-bar'
});

const props = defineProps({
  loggedUser: {
    type: Object,
    default: null
  }
});

const hasPaymentsAccess = isAppAllowed(APPS.PAYMENTS.key);

const { waitingValue, validationAccount, initializeBalance, refreshBalance } = usePaymentsBalance();

const footerMenuItems = [
  {
    label: 'Sair',
    to: { path: '/logout' },
    show: true
  }
];

const profileMenuItemGroups = reactive([
  {
    label: 'Configurações',
    items: [
      {
        label: 'Minha empresa',
        to: { name: 'Admin' },
        show: false
      },
      {
        label: 'Minha conta',
        to: { name: 'MyAccount' },
        show: false
      },
      {
        label: 'Desenvolvedor',
        to: { name: 'DeveloperArea' },
        show: false
      }
    ]
  },
  {
    label: 'Ajuda',
    items: [
      {
        label: 'Status page',
        to: 'https://status.transfeera.com/',
        show: config.branding.showStatusMenu
      }
    ]
  }
]);

const visibleProfileMenuItemGroups = computed(() =>
  profileMenuItemGroups
    .map(group => ({
      ...group,
      items: group.items.filter(item => item.show)
    }))
    .filter(group => group.items.length > 0)
);

let balanceRefreshInterval;

function checkMenuItems() {
  profileMenuItemGroups.forEach(group => {
    group.items.forEach(item => {
      if (item.to?.name) {
        item.show = useAllowedRoute(item.to.name).show;
      }
    });
  });
}

function refreshItems() {
  return refreshBalance();
}

function setListeners() {
  balanceRefreshInterval = window.setInterval(refreshItems, 60000);

  window.addEventListener('topbar.refresh', refreshItems);
  window.addEventListener('balance.refresh', refreshItems);
}

checkMenuItems();

if (hasPaymentsAccess) {
  void initializeBalance();
}

onMounted(() => {
  if (hasPaymentsAccess) {
    setListeners();
  }
});

onBeforeUnmount(() => {
  window.clearInterval(balanceRefreshInterval);
  window.removeEventListener('topbar.refresh', refreshItems);
  window.removeEventListener('balance.refresh', refreshItems);
});
</script>
